/**
 * 자동 생성 — scripts/site-media/build.mjs (site). 직접 고치지 말고 원본·설정을 바꾼 뒤 다시 돌린다.
 * 값: d 폴더·h 해시·w 너비 변형·r 가로/세로·c 대표 색·q 흐린 미리보기·v 영상 렌디션·p 포스터 너비.
 */
export const SITE_ASSET_IMAGES = {
  "drone_work": {"d":"img","h":"404575a9ac","w":[800,1600],"r":1.4995,"c":"#d8e8e8","q":"data:image/webp;base64,UklGRpwAAABXRUJQVlA4IJAAAACwBACdASoYABAAPu1iqU2ppaOiMAgBMB2JaACdMoADK/xTMaQybYv2b4A2nTfwAMqyR3juuZ62plUY/lS4kypdHKFO7YauiICOSHX0uITk91YiF+ksrXkGbu0xzn3VJGT3P2PxVt6RdRRaYQpphgSLRb/KV1IRzgh1rt/W2/rMJk5Rn8BJWw5NEioVRzs1xAA="},
  "drone_forest2": {"d":"img","h":"f5b25cf73d","w":[800,1600],"r":1.4995,"c":"#182818","q":"data:image/webp;base64,UklGRnIAAABXRUJQVlA4IGYAAAAwBACdASoYABAAPu1iqU2ppaQiMAgBMB2JZQC7CGABSWQ4/AFhZSWNMAAA/nQEGOVyysVXEn6ac7D8xetK9TLH2/Db5/VEiLDV8bcvT+P4/pwRdb3Z8ydv2GcFWHbyLRymdXpRAAA="},
  "airspace_chart": {"d":"img","h":"b681b6d296","w":[480,960],"r":1.5023,"c":"#c8c8c8"},
  "drone_sky": {"d":"img","h":"5cecce7806","w":[800,960],"r":1.5,"c":"#3878a8"},
  "station": {"d":"img","h":"1dee7588fc","w":[800,1600],"r":1.3333,"c":"#485848"},
  "interchange": {"d":"img","h":"bad02394ca","w":[800,1600],"r":1.4995,"c":"#182828"},
  "step5_3d": {"d":"data","h":"5cedb51339","w":[480,720],"r":0.8,"c":"#c8d8e8"},
  "contour": {"d":"data","h":"4e521d6c4a","w":[960,1900],"r":1.5833,"c":"#f8f8f8"},
  "edu_ctrl": {"d":"img","h":"94987eec2b","w":[800,1200],"r":1.5,"c":"#181818"},
  "plans_c": {"d":"img","h":"3419da8132","w":[800],"r":1.5009,"c":"#e8e8f8"},
  "clipboard": {"d":"img","h":"72ef120d09","w":[800,960],"r":1.5,"c":"#f8f8f8"},
  "gear": {"d":"img","h":"9ebd7c8d91","w":[800,960],"r":1.3333,"c":"#889898"},
  "res_ortho": {"d":"data","h":"761ca89a14","w":[800,1600],"r":1.6,"c":"#b89878"},
  "res_dsm": {"d":"data","h":"fc29014610","w":[800,1600],"r":1.6,"c":"#e83828"},
  "res_pc": {"d":"data","h":"6283e26d8e","w":[800,1600],"r":1.6,"c":"#181818"},
  "res_mesh": {"d":"data","h":"df55e0925b","w":[800,1600],"r":1.6,"c":"#b89878"},
  "res_contour": {"d":"data","h":"79c0725c48","w":[800,1600],"r":1.6,"c":"#f8f8f8"},
  "ortho_now": {"d":"data","h":"af11110c4a","w":[960,1900],"r":1.5833,"c":"#484838"},
  "hero635_ui": {"d":"platform","h":"c1e233041f","w":[1600,2400,3200],"r":1.6,"c":"#f8f8f8"},
  "ortho_past": {"d":"data","h":"f45a617328","w":[1900],"r":1.5833,"c":"#d8c8a8"},
  "ortho3d": {"d":"data","h":"b57c6a8f44","w":[800,1600],"r":1.6,"c":"#f8f8f8"},
  "geolog_vcard": {"d":"shots","h":"feb567520f","w":[400,560],"r":1.0108,"c":"#f8f8f8"},
  "br_ortho": {"d":"data/br","h":"a7acd311ee","w":[520,1040],"r":1.04,"c":"#d8c8b8"},
  "pf_layers": {"d":"shots","h":"a71d50b604","w":[960,1600],"r":2.2191,"c":"#f8f8f8"},
  "ew_summary": {"d":"shots","h":"e788af5002","w":[960,1600],"r":1.6,"c":"#f8f8f8"},
  "measure_zoom": {"d":"shots","h":"08995799b1","w":[960,1280],"r":1.6,"c":"#d8b898"},
  "issue_side": {"d":"shots","h":"0c004a78d5","w":[960,1530],"r":1.335,"c":"#f8f8f8"},
  "geolog_side": {"d":"shots","h":"41997c83d0","w":[960,1872],"r":1.6,"c":"#f8f8f8"},
  "roadview_full": {"d":"shots","h":"fe01f246b1","w":[1280,2048],"r":1.6,"c":"#282828"},
} as const;

export const SITE_ASSET_VIDEOS = {
  "hero635_3d": {"d":"platform","h":"7179a0feab","v":[1216,1936,2416],"p":[1216,1936],"q":"data:image/webp;base64,UklGRroAAABXRUJQVlA4IK4AAADQBACdASoYABMAPu1qq1EppaOiqAqpMB2JYwDE+JlBXqJi580Pq7y/duhEn7IvAAD+59VYfARs4VPx1q1b3uJoYwosvdUUmbwQqIxSYIz4uHfVifGKq8cGcOlY2mKEPgazMdonBZN2rWsiQOcIkEqP5H9ghuab78b3KPwH0u2a3eY4e+fjQSCg3FMXukPztVCCUR1zI7GZkDipANjtIxBzNo/tOxn/LBiOZ0AAAAA="},
  "ws3d_sim": {"d":"video","h":"b1213aa68e","v":[1280],"p":[960],"q":"data:image/webp;base64,UklGRp4AAABXRUJQVlA4IJIAAABQBACdASoYAA8APu1iqU2ppaOiMAgBMB2JQBOmUAS4Afv0WWLP49uWRfwAAPiuxEXqDL+JidksLAiR9Z7iQhDCf3vSqipowE4NRPj7nDaBREZf6uihEJ5xLeQUyR2fG3XsVGBXZatA5zR9WgZkkXT1EzvBl7F7hy41pAXQK2VhDRQUXrRK3oJdgiIPMUxk1qvQAA=="},
  "ws3d_sim2": {"d":"video","h":"4c1a2528d4","v":[1280],"p":[960],"q":"data:image/webp;base64,UklGRo4AAABXRUJQVlA4IIIAAACQAwCdASoYAA8APu1iqU2ppaOiMAgBMB2JQBOmUAA7p+mmDTHAAMosszvw5LDziOI15KhITKVIMydsALNO1KfbtD0WDPt5d1B2y4v66N9NfWqVrA31JWY52BL60HB+oVhOu2z0C4j0Uwwoy/7LrNdG6boAjkAZAvSzkwBWYAabAAAA"},
} as const;

export const SITE_ASSET_FILES = {
  "art/tile_platform.svg": "art/tile_platform.63e8275b81.svg",
  "art/tile_survey.svg": "art/tile_survey.6b9a9b0746.svg",
  "art/tile_manual.svg": "art/tile_manual.8c807507d8.svg",
  "art/tile_plan.svg": "art/tile_plan.1e4aeaa89b.svg",
  "art/tile_releases.svg": "art/tile_releases.45896dda9f.svg",
  "art/guide_player.svg": "art/guide_player.d7e89f17d4.svg",
  "logo/logo-soosungeng.png": "logo/logo-soosungeng.955f26af1d.png",
  "logo/logo-hyundai.png": "logo/logo-hyundai.697d19da75.png",
  "logo/logo-taeyoung.png": "logo/logo-taeyoung.3721b0885a.png",
  "logo/logo-hj.png": "logo/logo-hj.d10a17e788.png",
  "logo/logo-udae-enp.png": "logo/logo-udae-enp.d908ef428a.png",
  "logo/logo-punglim.png": "logo/logo-punglim.7b98885e0a.png",
  "logo/logo-hwalrim.png": "logo/logo-hwalrim.d8c24cb8e9.png",
  "logo/logo-eochon-eoang.png": "logo/logo-eochon-eoang.5579d7710d.png",
  "logo/logo-kwater.png": "logo/logo-kwater.befbafa866.png",
  "logo/logo-libera.png": "logo/logo-libera.e596d41c68.png",
  "logo/logo-eco.png": "logo/logo-eco.8cb5aa18a5.png",
  "data/ortho_past.ktx2": "data/ortho_past.119045de6a.ktx2",
  "data/h_now.png": "data/h_now.bcfb8364f5.png",
  "data/h_past.png": "data/h_past.f7300374e1.png",
  "data/tmask.png": "data/tmask.98f258a21b.png",
  "ui/marker-sharp.png": "ui/marker-sharp.28a472ded7.png",
  "data/br/br_ortho.ktx2": "data/br/br_ortho.bc473d99b3.ktx2",
  "data/br/br_h.png": "data/br/br_h.90b1b0a679.png",
  "data/br/br_bim.bin": "data/br/br_bim.5f782b1939.bin",
  "data/br/br_profile.json": "data/br/br_profile.47b5a287a4.json",
  "data/ortho_now.ktx2": "data/ortho_now.e5e51ef2a9.ktx2",
  "data/res_h.png": "data/res_h.f5a431889a.png",
  "release-art/auto_mapping.svg": "release-art/auto_mapping.8119e29ed2.svg",
  "release-art/equip_sim.svg": "release-art/equip_sim.fe9c2539e1.svg",
  "release-art/linear_ew.svg": "release-art/linear_ew.43e6c7a82f.svg",
  "release-art/ew_summary.svg": "release-art/ew_summary.6fc8277b51.svg",
  "release-art/folders.svg": "release-art/folders.28508b6b38.svg",
  "release-art/walk_roadview.svg": "release-art/walk_roadview.9908734d35.svg",
  "release-art/history.svg": "release-art/history.e713616f41.svg",
  "release-art/area_capture.svg": "release-art/area_capture.18bd6aa4a8.svg",
  "release-art/issue_comments.svg": "release-art/issue_comments.5d348cf836.svg",
  "release-art/pano360.svg": "release-art/pano360.e83c6817c4.svg",
  "release-art/clip_box.svg": "release-art/clip_box.d36609a853.svg",
  "release-art/dsm_color.svg": "release-art/dsm_color.5a455b6e8f.svg",
  "release-art/vectors.svg": "release-art/vectors.aad07fa989.svg",
  "release-art/workers.svg": "release-art/workers.78ef5f95f4.svg",
  "release-art/first_person.svg": "release-art/first_person.1ea496e354.svg",
  "release-art/geolog_map.svg": "release-art/geolog_map.29f13dc6c9.svg",
  "release-art/ja.svg": "release-art/ja.31548c2cff.svg",
  "release-art/dxf_on_3d.svg": "release-art/dxf_on_3d.168135dc03.svg",
  "release-art/profile_3d.svg": "release-art/profile_3d.dd68ce758f.svg",
} as const;

export const SITE_ASSET_DIRS = {
  "story": {"d":"data/s635n3d.7ff2f72552","q":"data:image/webp;base64,UklGRnoAAABXRUJQVlA4IG4AAABQBACdASoYAAsAPu1iqU2ppaOiMAgBMB2JYgCdMoRwACxwP8m6aLw3GeNUAPxmBfCcjylZViOxQQeybpUtT8i2UVn7WbkDBHgcwJyoFX8rsvmu1YIBIerbPRjvARzXG90tOTQUEIRsgsjNOQAAAA=="},
} as const;

